export default __webpack_public_path__ + "static/media/circle_loader.4a8451b1.gif";